export default "__VITE_ASSET__zTi7sjVK__"